export const determineMinimumPercentEarned = (featureCriteriaArr) => {

    let minimumPercent = 100;
    for (let i=0; i<featureCriteriaArr.length; i++){
        const featureCriteria = featureCriteriaArr[i];
        //  if textColor is green, it means the player has met this criteria (pct is 100);
        if (featureCriteria.textColor !== "green"){
            let playerValue = featureCriteria.playerValue;
            if (featureCriteria.playerValue < 0){
                playerValue = 0;
            }
            let criteriaPercent = +playerValue / +featureCriteria.criteriaValue * 100;
            if (criteriaPercent > 100){
                criteriaPercent = 100;
            }
            if (+criteriaPercent < +minimumPercent){;
                minimumPercent = +criteriaPercent;
            }
        }
    } 
    switch (true){
        case +minimumPercent === 100:
            minimumPercent = 100
            break;
        case +minimumPercent >= 75:   
            minimumPercent = 55;
            break;
        case minimumPercent >= 50:   
            minimumPercent = 40;
            break;
        case minimumPercent >= 25:   
            minimumPercent = 15;
            break;
        default:
            minimumPercent = 2;    
            break;
    }
    return minimumPercent;
}
export default determineMinimumPercentEarned;